import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import {
  JournalRow,
  JournalStageColumn,
} from 'donor-elf-web/lib/journal-utils';
import JournalDecisionInfo from 'donor-elf-web/lib/models/journal-decision-info';
import V2TaskModel from 'donor-elf-web/models/v2-task';

interface JournalCellDecisionComponentArgs {
  journalRow: JournalRow;
  journalDecisionInfo: JournalDecisionInfo;
  journalStageColumn: JournalStageColumn;
  slimView?: boolean;
  onChange: (args: {
    taskSaved?: V2TaskModel;
    taskDeleted?: V2TaskModel;
    taskPasted?: boolean;
  }) => void;
}

export default class JournalCellDecisionIndexComponent extends Component<JournalCellDecisionComponentArgs> {
  get journalContactInfo() {
    return this.args.journalRow.journalContactInfo;
  }

  get journalDecision() {
    return this.args.journalDecisionInfo?.journalDecision;
  }

  get slimView() {
    return this.args.slimView ?? false;
  }

  get journalHasMultipleGoals() {
    return this.args.journalRow.journalContactInfo.journalInfo.hasMultipleGoals;
  }

  get journalGoal() {
    return this.args.journalDecisionInfo?.journalGoal;
  }

  get pledge() {
    return this.args.journalDecisionInfo?.pledge;
  }

  get highlightDecisionButton() {
    return this.journalContactInfo.decisionStage.waitingOnDecision;
  }

  get decisionLeftBorderColorClass() {
    if (this.journalDecision.yesNo) {
      if (this.decisionWarning) {
        return 'bg-warning';
      } else {
        return 'bg-brand';
      }
    } else {
      return 'bg-secondary';
    }
  }

  @cached
  get decisionWarning() {
    if (!this.journalDecision.yesNo) {
      return null;
    }

    if (!this.pledge?.hasGifts) {
      return 'No gift yet';
    }

    // Commenting out for now.  This was causing a lot of confusion since we look
    // at the last gift, not the gift associated with the pledge.  A follow up
    // story will address this.

    // if (
    //   this.journalContactInfo.lastGift &&
    //   this.journalContactInfo.lastGift.amount < (this.pledge.amount || 0)
    // ) {
    //   return 'Gift below pledge amount';
    // }

    return null;
  }
}
